var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFooterBgLeft = function SvgFooterBgLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 600,
    viewBox: "0 0 600 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2875_20364",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 600,
    height: 600
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 600,
    fill: "url(#paint0_linear_2875_20364)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2875_20364)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 196,
    cy: 196,
    r: 196,
    fill: "#DDF4E7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 92,
    r: 92,
    transform: "matrix(1 0 0 -1 416 366)",
    fill: "#E3F0F1"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 196,
    cy: 196,
    r: 196,
    transform: "matrix(1 0 0 -1 208 774)",
    fill: "#EAE8F6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(1 0 0 -1 520 158)",
    fill: "#F8E9F1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    transform: "matrix(1 0 0 -1 416 162)",
    fill: "#FAEDE0"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2875_20364",
    x1: 300,
    y1: 0,
    x2: 300,
    y2: 600,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
};
export { SvgFooterBgLeft as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAwIiBoZWlnaHQ9IjYwMCIgdmlld0JveD0iMCAwIDYwMCA2MDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxnIG9wYWNpdHk9IjAuMDUiPgo8bWFzayBpZD0ibWFzazBfMjg3NV8yMDM2NCIgc3R5bGU9Im1hc2stdHlwZTphbHBoYSIgbWFza1VuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeD0iMCIgeT0iMCIgd2lkdGg9IjYwMCIgaGVpZ2h0PSI2MDAiPgo8cmVjdCB3aWR0aD0iNjAwIiBoZWlnaHQ9IjYwMCIgZmlsbD0idXJsKCNwYWludDBfbGluZWFyXzI4NzVfMjAzNjQpIi8+CjwvbWFzaz4KPGcgbWFzaz0idXJsKCNtYXNrMF8yODc1XzIwMzY0KSI+CjxjaXJjbGUgY3g9IjE5NiIgY3k9IjE5NiIgcj0iMTk2IiBmaWxsPSIjRERGNEU3Ii8+CjxjaXJjbGUgY3g9IjkyIiBjeT0iOTIiIHI9IjkyIiB0cmFuc2Zvcm09Im1hdHJpeCgxIDAgMCAtMSA0MTYgMzY2KSIgZmlsbD0iI0UzRjBGMSIvPgo8Y2lyY2xlIG9wYWNpdHk9IjAuNiIgY3g9IjE5NiIgY3k9IjE5NiIgcj0iMTk2IiB0cmFuc2Zvcm09Im1hdHJpeCgxIDAgMCAtMSAyMDggNzc0KSIgZmlsbD0iI0VBRThGNiIvPgo8Y2lyY2xlIGN4PSIxMiIgY3k9IjEyIiByPSIxMiIgdHJhbnNmb3JtPSJtYXRyaXgoMSAwIDAgLTEgNTIwIDE1OCkiIGZpbGw9IiNGOEU5RjEiLz4KPGNpcmNsZSBjeD0iNDAiIGN5PSI0MCIgcj0iNDAiIHRyYW5zZm9ybT0ibWF0cml4KDEgMCAwIC0xIDQxNiAxNjIpIiBmaWxsPSIjRkFFREUwIi8+CjwvZz4KPC9nPgo8ZGVmcz4KPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDBfbGluZWFyXzI4NzVfMjAzNjQiIHgxPSIzMDAiIHkxPSIwIiB4Mj0iMzAwIiB5Mj0iNjAwIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIHN0b3AtY29sb3I9IndoaXRlIi8+CjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0id2hpdGUiIHN0b3Atb3BhY2l0eT0iMCIvPgo8L2xpbmVhckdyYWRpZW50Pgo8L2RlZnM+Cjwvc3ZnPgo=";